"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMockContractUserRound = void 0;
const constants_1 = require("../../../constants");
const perpetual_1 = require("../../perpetual");
const anchor_1 = require("@project-serum/anchor");
const getMockContractUserRound = (args) => {
    const programPubkey = new anchor_1.web3.PublicKey(args.programId);
    const roundPubkey = new anchor_1.web3.PublicKey(args.roundPubkey);
    const [userContractBid] = anchor_1.web3.PublicKey.findProgramAddressSync([constants_1.ENCODER.encode("user_contract_bid"), roundPubkey.toBuffer()], programPubkey);
    const [userRoundContractBid] = anchor_1.web3.PublicKey.findProgramAddressSync([constants_1.ENCODER.encode("user_round_contract_bid"), roundPubkey.toBuffer()], programPubkey);
    // const randomKeypairUser = new Keypair();
    const userRound = {
        round: args.roundPubkey,
        solDeposited: args.contractBid,
        startSolPosition: 0,
        user: userContractBid.toBase58(),
        lastTransactedAt: (0, perpetual_1.nowInSeconds)(),
        depositedAt: (0, perpetual_1.nowInSeconds)(),
        nftMint: "",
        jackpotSolAmount: 0,
        jackpotClaimedAt: 0,
        jackpotClaimed: false,
        publicKey: userRoundContractBid.toBase58(),
        placeholderOne: 0,
        placeholderTwo: 0,
        placeholderThree: false,
        placeholderFour: false,
        placeholderFive: false
    };
    return userRound;
};
exports.getMockContractUserRound = getMockContractUserRound;
